import {
  green,
  indigo,
  lightBlue,
  orange,
  purple,
  red,
} from "@mui/material/colors";

export const AVAILABILITY_DASHBOARD_COLUMNS = [
  { field: "mmid", headerName: "MMID", minWidth: 150 },
  { field: "description", headerName: "Description", minWidth: 200 },
  {
    field: "vendor_location_display_name",
    headerName: "Location",
    minWidth: 150,
  },
  { field: "seller_name", headerName: "Seller", minWidth: 150 },
  { field: "vendor_location_key", headerName: "Vendor Master ID", minWidth: 150 },
  {
    field: "physical_inventory",
    headerName: "Physical Inventory",
    minWidth: 80,
  },
  { field: "planned_inventory", headerName: "Planned Inventory", minWidth: 80 },
  { field: "es_derived", sortField: "derived_inventory", headerName: "Derived", minWidth: 80 },
  { field: "reserved", headerName: "Reserved", minWidth: 80 },
  { field: "available_qty", sortField: "net_available", headerName: "Net Available", minWidth: 80 },
  { field: "eta", headerName: "Lead Time", minWidth: 180 },
];

export const RESERVATION_LEDGER_COLUMNS = [
  { field: "event_id", headerName: "Event Id", minWidth: 120 },
  { field: "reference_type", headerName: "Ref Type", minWidth: 120 },
  { field: "reference_id", headerName: "Reference ID", minWidth: 150 },
  { field: "mm_id", headerName: "MMid", minWidth: 120 },
  {
    field: "vendor_location_display_name",
    headerName: "Location",
    minWidth: 150,
  },
  { field: "seller_name", headerName: "Seller", minWidth: 150 },
  { field: "qty", headerName: "Qty", minWidth: 90 },
  { field: "event_type", headerName: "Action", minWidth: 120 },
  { field: "status", headerName: "Status", minWidth: 120 },
  { field: "event_timestamp", headerName: "Timestamp", minWidth: 180 },
];

export const ES_MM_MAPPING_COLUMNS = [
  { field: "fm_mmid", headerName: "FM MMid", minWidth: 200 },
  { field: "fm_description", headerName: "FM Description", minWidth: 300 },
  { field: "rm_mmid", headerName: "RM MMid", minWidth: 200 },
  { field: "rm_description", headerName: "RM Description", minWidth: 300 },
  { field: "type", headerName: "Type", minWidth: 150 },
];

export const AVAILABILITY_FILTER_FIELDS = [
  {
    name: "mm_ids",
    ui_label: "Search MMid",
    ui_type: "string",
    value_type: "string",
    override_config: { gridSize: 2 },
    options: null,
    default_value: null,
  },
  {
    name: "mm_description",
    ui_label: "Search Description",
    ui_type: "string",
    value_type: "string",
    override_config: { gridSize: 2 },
    options: null,
    default_value: null,
  },
  {
    name: "vmid",
    ui_label: "Search VMID",
    ui_type: "string",
    value_type: "string",
    override_config: { gridSize: 2 },
    options: null,
    default_value: null,
  },
  {
    name: "seller",
    ui_label: "All Sellers",
    ui_type: "select",
    value_type: "string",
    override_config: { gridSize: 3 },
    options: null,
    default_value: null,
  },
  {
    name: "vendor_ids",
    ui_label: "All Locations",
    ui_type: "multi_select_menu",
    value_type: "string",
    override_config: { gridSize: 3, parent_key: ["seller"] },
    options: null,
    default_value: null,
  },
  {
    name: "to_date",
    ui_label: "Date",
    ui_type: "date",
    value_type: "string",
    override_config: { gridSize: 2, default_time: "23:59:59" },
    options: null,
    default_value: null,
  },
  {
    name: "qty_type",
    ui_label: "QTY type",
    ui_type: "select",
    value_type: "string",
    override_config: { gridSize: 3 },
    options: [
      { label: "Planned", value: "planned_inventory" },
      { label: "Derived inventory", value: "derived_inventory" },
      { label: "Physical Inventory", value: "physical_inventory" },
      { label: "Net Available", value: "net_available" },
      { label: "Reserved", value: "reserved" },
    ],
    default_value: null,
  },
  {
    name: "qty_condition",
    ui_label: "Condition",
    ui_type: "select",
    value_type: "string",
    override_config: { gridSize: 3 },
    options: ["> zero", "No criteria", "= zero"],
    default_value: null,
  },
];

export const RESERVATION_LEDGER_FILTER_FIELDS = [
  {
    name: "mm_id",
    ui_label: "MMid",
    ui_type: "string",
    value_type: "string",
    override_config: { gridSize: 2 },
    options: null,
    default_value: null,
  },
  {
    name: "reference_id",
    ui_label: "Reference ID",
    ui_type: "string",
    value_type: "string",
    override_config: { gridSize: 2 },
    options: null,
    default_value: null,
  },
  {
    name: "seller",
    ui_label: "All Sellers",
    ui_type: "select",
    value_type: "string",
    override_config: { gridSize: 2 },
    options: null,
    default_value: null,
  },
  {
    name: "vendor_ids",
    ui_label: "All Locations",
    ui_type: "multi_select_menu",
    value_type: "string",
    override_config: { gridSize: 2, parent_key: ["seller"] },
    options: null,
    default_value: [],
  },
  {
    name: "action",
    ui_label: "Action",
    ui_type: "select_static",
    value_type: "string",
    override_config: { gridSize: 2 },
    options: [
      { label: "Reserve", value: "reserve" },
      { label: "Unreserve", value: "unreserve" },
    ],
    default_value: null,
  },
  {
    name: "status",
    ui_label: "Status",
    ui_type: "string",
    value_type: "string",
    override_config: null,
    options: null,
    default_value: null,
  },
  {
    name: "from_date",
    ui_label: "From Date",
    ui_type: "date",
    value_type: "string",
    override_config: { gridSize: 1.5, default_time: "23:59:59" },
    options: null,
    default_value: null,
  },
  {
    name: "to_date",
    ui_label: "To Date",
    ui_type: "date",
    value_type: "string",
    override_config: { gridSize: 1.5, default_time: "23:59:59" },
    options: null,
    default_value: null,
  },
];

export const ES_MM_MAPPING_FILTER_FIELDS = [
  {
    name: "mmid",
    ui_label: "Enter FM MMid (e.g. 1000-10000-10013298)",
    ui_type: "string",
    value_type: "string",
    override_config: { gridSize: 3 },
    options: null,
    default_value: null,
  },
];

export const TOP_METRICS_CONFIG = [
  {
    id: "total_available",
    label: "Total Available Qty",
    value: "--",
    unit: "--",
    color: green[700],
  },
  {
    id: "reserved",
    label: "Reserved Qty",
    value: "--",
    unit: "--",
    color: orange[700],
  },
  {
    id: "active_mmids",
    label: "Active MMids",
    value: "--",
    unit: "",
    color: lightBlue[700],
  },
  {
    id: "critical_stock",
    label: "Critical Stock Items",
    value: "--",
    unit: "",
    color: red[700],
  },
];

export const INNER_METRICS_CONFIG = [
  { id: "physical_inventory", label: "Physical Inventory", color: green[700] },
  {
    id: "planned_inventory",
    label: "Planned Inventory",
    color: lightBlue[700],
  },
  { id: "es_derived", label: "ES Derived", color: purple[500] },
  { id: "reserved", label: "Reserved", color: orange[600] },
  { id: "net_available", label: "Net Available", color: indigo[900] },
];
